exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-radio{overflow:hidden;-webkit-user-select:none;user-select:none}.van-radio__icon,.van-radio__label{display:inline-block;vertical-align:middle;line-height:20px}.van-radio__icon{height:20px}.van-radio__icon .van-icon{font-size:14px;color:transparent;text-align:center;line-height:inherit;width:20px;height:20px;box-sizing:border-box;border:1px solid #e5e5e5;-webkit-transition:.2s;transition:.2s}.van-radio__icon--round .van-icon{border-radius:100%}.van-radio__icon--checked .van-icon{color:#fff;border-color:#1989fa;background-color:#1989fa}.van-radio__icon--disabled .van-icon{border-color:#c8c9cc;background-color:#ebedf0}.van-radio__icon--disabled.van-radio__icon--checked .van-icon{color:#c8c9cc}.van-radio__label{color:#323233;margin-left:10px}.van-radio__label--left{float:left;margin:0 10px 0 0}.van-radio__label--disabled{color:#c8c9cc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vant/es/radio/index.css
// module id = 199
// module chunks = 0